export const SET_TOKEN_RECAPTCHA = "TBEXTERNO_REDESIM_SET_TOKEN_RECAPTCHA";
export const SET_TOKEN_RECAPTCHA_MODAL = "TBEXTERNO_REDESIM_SET_TOKEN_RECAPTCHA_MODAL";
export const PESQUISAR_CONSULTAR_PROTOCOLO = "TBEXTERNO_PESQUISAR_CONSULTAR_PROTOCOLO";
export const SET_GRID_CONSULTAR_PROTOCOLO = "TBEXTERNO_SET_GRID_CONSULTAR_PROTOCOLO";
export const TOGGLE_MODAL_CONSULTAR_PROTOCOLO = "TBEXTERNO_REDESIM_TOGGLE_MODAL_CONSULTAR_PROTOCOLO";
export const ABRIR_CONSULTAR_PROTOCOLO = "TBEXTERNO_ABRIR_CONSULTAR_PROTOCOLO";
export const PESQUISAR_CONSULTAR_PROTOCOLO_MODAL = "TBEXTERNO_PESQUISAR_CONSULTAR_PROTOCOLO_MODAL";
export const SET_GRID_PESQUISA_CONSULTAR_PROTOCOLO = "TBEXTERNO_SET_GRID_PESQUISA_CONSULTAR_PROTOCOLO";
export const SET_HEADER_CONSULTAR_PROTOCOLO = "TBEXTERNO_SET_HEADER_CONSULTAR_PROTOCOLO";
export const VIEW_ANALISE_CONSULTAR_PROTOCOLO = "TBEXTERNO_VIEW_ANALISE_CONSULTAR_PROTOCOLO";
export const TOOGLE_MODAL_VIEW_ANALISE = "TBEXTERNO_TOOGLE_MODAL_VIEW_ANALISE";
export const SET_VIEW_ANALISE = "TBEXTERNO_SET_VIEW_ANALISE";
export const MODAL_VIEW_ANALISE = "TBEXTERNO_MODAL_VIEW_ANALISE";
export const LIMPA_GRIDS_CONSULTAR_PROTOCOLO = "TBEXTERNO_LIMPA_GRIDS_CONSULTAR_PROTOCOLO";
export const SET_RECAPTCHA_RESET_REF = "TBEXTERNO_SET_RECAPTCHA_RESET_REF";
export const SET_RECAPTCHA_RESET_REF_MODAL = "TBEXTERNO_SET_RECAPTCHA_RESET_REF_MODAL";
